import React, { useEffect } from 'react';
//import { ReactComponent as Spinner} from '../assets/img/logo_loading.svg';
import { EnvironmentLabel, FullscreenMessage, Icon } from '../components';
import { useGlobalState, useMessage } from '../hooks';

export const LoadApp = () => {
  const [loggedInUser] = useGlobalState('loggedInUser');
  const [isLoggedIn] = useGlobalState('isLoggedIn');

  const { message } = useMessage();

  useEffect(() => {
    // Redirect to start page if user is already logged in
    if (isLoggedIn && loggedInUser && !loggedInUser.password_change_required) {
      //navigate('/')
    }
  }, []);

  return (
    <div className="Login fullscreen">
      <div className="fullscreen-container-wrapper">
        <div className="fullscreen-container">
          <div className="fullscreen-logo">
            <Icon name="katalogue" className="loading" />
            <EnvironmentLabel />
          </div>

          {/* !message || Object.keys(message).length === 0
            ? <Spinner className="fullscreen-loading-logo" />
            : <div className="fullscreen-logo"></div>
          */}

          {message && message.type === 'error' ? (
            <FullscreenMessage message={message} />
          ) : (
            <div className="fullscreen-loading-text">Loading Katalogue...</div>
          )}
        </div>
      </div>
    </div>
  );
};
